import styled, { css } from 'styled-components';

import checkboxStd from '~/styled/checkbox';
import font from '~/styled/font';

export const Checkbox = styled.input`
  ${checkboxStd};
  flex: none;
  width: ${({ iconSize }) => iconSize};
  height: ${({ iconSize }) => iconSize};
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: ${({ isDisabled }) => isDisabled ? 'default' : 'pointer'};
  -webkit-tap-highlight-color: transparent;
  outline: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
`;

export const TextContent = styled.div`
  ${({ checkboxPosition }) => checkboxPosition === 'left' ? css`
    margin-left: 4px;
  ` : checkboxPosition === 'right' ? css`
    margin-right: 4px;
  ` : ``}
  
  color: ${({ isDisabled }) => isDisabled ? '#DFDFDF' : '#222222'};
  font-weight: 400;
  ${font.body3};
  
  > span {
    white-space: pre-wrap;
  }
`;
